export const setTabIndex = (selector: string, tabbable: boolean) => {
  const focusable = Array.from(document.querySelectorAll<HTMLElement>(selector));
  focusable.forEach((el: HTMLElement) => {
    const element = el;
    element.tabIndex = tabbable ? 0 : -1;
  });
};
